// Generated by ReScript, PLEASE EDIT WITH CARE


var value = {"restrictions" : [
    {
        "id": 3,
        "polygon": [
            [
                [
                    55.40851723727393,
                    25.263013413277243
                ],
                [
                    55.41710030612158,
                    25.271008184101312
                ],
                [
                    55.423280115691895,
                    25.278653176236897
                ],
                [
                    55.44032823619055,
                    25.271706731294234
                ],
                [
                    55.42785059985327,
                    25.259248702944145
                ],
                [
                    55.41764747676062,
                    25.256298951441835
                ],
                [
                    55.40851723727393,
                    25.263013413277243
                ]
            ]
        ],
        "restriction_type": "Pickup",
        "start_minutes": 0,
        "end_minutes": 1440,
        "vehicle_ids": [],
        "message": {
            "title": "Restricted area",
            "message": "Pickup is restricted in the area due to govt rules"
        }
    },
    {
        "id": 4,
        "polygon": [
            [
                [
                    55.31533551749709,
                    25.220502625018593
                ],
                [
                    55.321686988444355,
                    25.219629072356568
                ],
                [
                    55.32089305457595,
                    25.214504103728963
                ],
                [
                    55.31440210875991,
                    25.215426225753266
                ],
                [
                    55.31533551749709,
                    25.220502625018593
                ]
            ]
        ],
        "restriction_type": "Both",
        "start_minutes": 0,
        "end_minutes": 1440,
        "vehicle_ids": [],
        "message": {
            "title": "Restricted area",
            "message": "Pickup and drop is restricted in the area due to govt rules"
        }
    },
    {
        "id": 36,
        "polygon": [
            [
                [
                    52.55356498,
                    23.5151492
                ],
                [
                    52.55356498,
                    26.0633666
                ],
                [
                    55.639401,
                    26.0633666
                ],
                [
                    55.639401,
                    25.4314593
                ],
                [
                    55.63978383,
                    25.4314593
                ],
                [
                    55.628939,
                    25.4138873
                ],
                [
                    55.629744,
                    25.4124513
                ],
                [
                    55.629947,
                    25.4115183
                ],
                [
                    55.629968,
                    25.4105843
                ],
                [
                    55.62958,
                    25.4097623
                ],
                [
                    55.626274,
                    25.4058693
                ],
                [
                    55.620426,
                    25.3991543
                ],
                [
                    55.614773,
                    25.3927873
                ],
                [
                    55.600486,
                    25.3763903
                ],
                [
                    55.595133,
                    25.3701963
                ],
                [
                    55.593821,
                    25.3689913
                ],
                [
                    55.592438,
                    25.3682903
                ],
                [
                    55.591599,
                    25.3680773
                ],
                [
                    55.590075,
                    25.3678733
                ],
                [
                    55.583963,
                    25.3673333
                ],
                [
                    55.578644,
                    25.3667983
                ],
                [
                    55.575385,
                    25.3665143
                ],
                [
                    55.55862,
                    25.3649483
                ],
                [
                    55.55309,
                    25.3644913
                ],
                [
                    55.539351,
                    25.3631643
                ],
                [
                    55.534609,
                    25.3623053
                ],
                [
                    55.518816,
                    25.3593883
                ],
                [
                    55.513288,
                    25.3583183
                ],
                [
                    55.510706,
                    25.3578463
                ],
                [
                    55.507026,
                    25.3572553
                ],
                [
                    55.50069,
                    25.3561353
                ],
                [
                    55.499788,
                    25.3560633
                ],
                [
                    55.498785,
                    25.3561313
                ],
                [
                    55.497165,
                    25.3565813
                ],
                [
                    55.494962,
                    25.3576303
                ],
                [
                    55.493439,
                    25.3578823
                ],
                [
                    55.492838,
                    25.3586913
                ],
                [
                    55.49201,
                    25.3591433
                ],
                [
                    55.466527,
                    25.3716063
                ],
                [
                    55.462038,
                    25.3738223
                ],
                [
                    55.457121,
                    25.3761463
                ],
                [
                    55.444018,
                    25.3838233
                ],
                [
                    55.438212,
                    25.3872343
                ],
                [
                    55.432092,
                    25.3908043
                ],
                [
                    55.429131,
                    25.3925773
                ],
                [
                    55.429067,
                    25.3930913
                ],
                [
                    55.428058,
                    25.3932073
                ],
                [
                    55.427114,
                    25.3939153
                ],
                [
                    55.425897,
                    25.3955403
                ],
                [
                    55.4244,
                    25.3973603
                ],
                [
                    55.422779,
                    25.3989113
                ],
                [
                    55.422522,
                    25.3987653
                ],
                [
                    55.422061,
                    25.3972053
                ],
                [
                    55.419738,
                    25.3948503
                ],
                [
                    55.41918,
                    25.3937253
                ],
                [
                    55.417935,
                    25.3927423
                ],
                [
                    55.416952,
                    25.3923843
                ],
                [
                    55.416307,
                    25.3915353
                ],
                [
                    55.415792,
                    25.3917583
                ],
                [
                    55.41533,
                    25.3905523
                ],
                [
                    55.413882,
                    25.3899123
                ],
                [
                    55.413126,
                    25.3890743
                ],
                [
                    55.412372,
                    25.3885983
                ],
                [
                    55.411591,
                    25.3884743
                ],
                [
                    55.410736,
                    25.3885673
                ],
                [
                    55.410538,
                    25.3891483
                ],
                [
                    55.410071,
                    25.3893503
                ],
                [
                    55.408833,
                    25.3883503
                ],
                [
                    55.407866,
                    25.3873653
                ],
                [
                    55.40763,
                    25.3868613
                ],
                [
                    55.406481,
                    25.3859873
                ],
                [
                    55.403272,
                    25.3831663
                ],
                [
                    55.403246,
                    25.3828763
                ],
                [
                    55.402554,
                    25.3826723
                ],
                [
                    55.402178,
                    25.3831283
                ],
                [
                    55.401846,
                    25.3827593
                ],
                [
                    55.401314,
                    25.3816693
                ],
                [
                    55.400467,
                    25.3811453
                ],
                [
                    55.400059,
                    25.3814313
                ],
                [
                    55.39948,
                    25.3808793
                ],
                [
                    55.399067,
                    25.3808743
                ],
                [
                    55.398935,
                    25.3812863
                ],
                [
                    55.397411,
                    25.3804563
                ],
                [
                    55.396114,
                    25.3795883
                ],
                [
                    55.39501,
                    25.3785743
                ],
                [
                    55.393036,
                    25.3769263
                ],
                [
                    55.393036,
                    25.3762863
                ],
                [
                    55.391577,
                    25.3757433
                ],
                [
                    55.390032,
                    25.3777403
                ],
                [
                    55.389539,
                    25.3779343
                ],
                [
                    55.389496,
                    25.3774103
                ],
                [
                    55.391384,
                    25.3746963
                ],
                [
                    55.391792,
                    25.3734163
                ],
                [
                    55.390655,
                    25.3727573
                ],
                [
                    55.389861,
                    25.3745803
                ],
                [
                    55.388766,
                    25.3741733
                ],
                [
                    55.388316,
                    25.3744443
                ],
                [
                    55.388208,
                    25.3735523
                ],
                [
                    55.385333,
                    25.3743083
                ],
                [
                    55.384732,
                    25.3748903
                ],
                [
                    55.385312,
                    25.3757823
                ],
                [
                    55.386299,
                    25.3755693
                ],
                [
                    55.386363,
                    25.3758593
                ],
                [
                    55.385827,
                    25.3764413
                ],
                [
                    55.388187,
                    25.3791553
                ],
                [
                    55.387822,
                    25.3795433
                ],
                [
                    55.3872,
                    25.3792723
                ],
                [
                    55.381471,
                    25.3738823
                ],
                [
                    55.370141,
                    25.3670773
                ],
                [
                    55.370549,
                    25.3666893
                ],
                [
                    55.372266,
                    25.3657193
                ],
                [
                    55.37263,
                    25.3658943
                ],
                [
                    55.373789,
                    25.3653323
                ],
                [
                    55.377437,
                    25.3674063
                ],
                [
                    55.377382,
                    25.3679503
                ],
                [
                    55.382791,
                    25.3710283
                ],
                [
                    55.384722,
                    25.3690513
                ],
                [
                    55.383048,
                    25.3683143
                ],
                [
                    55.381846,
                    25.3667633
                ],
                [
                    55.378842,
                    25.3634283
                ],
                [
                    55.37777,
                    25.3633893
                ],
                [
                    55.376053,
                    25.3642813
                ],
                [
                    55.37571,
                    25.3640103
                ],
                [
                    55.372276,
                    25.3588133
                ],
                [
                    55.367599,
                    25.3613733
                ],
                [
                    55.367169,
                    25.3611403
                ],
                [
                    55.366826,
                    25.3628853
                ],
                [
                    55.369186,
                    25.3695553
                ],
                [
                    55.368972,
                    25.3699433
                ],
                [
                    55.368414,
                    25.3696323
                ],
                [
                    55.366354,
                    25.3629243
                ],
                [
                    55.366612,
                    25.3566033
                ],
                [
                    55.366998,
                    25.3529193
                ],
                [
                    55.368028,
                    25.3525313
                ],
                [
                    55.368929,
                    25.3516783
                ],
                [
                    55.36777,
                    25.3500883
                ],
                [
                    55.367469,
                    25.3490023
                ],
                [
                    55.365716,
                    25.3463523
                ],
                [
                    55.364187,
                    25.3439453
                ],
                [
                    55.360979,
                    25.3387523
                ],
                [
                    55.358844,
                    25.3359313
                ],
                [
                    55.358715,
                    25.3344573
                ],
                [
                    55.346686,
                    25.3271623
                ],
                [
                    55.3529942,
                    25.3288566
                ],
                [
                    55.3552467,
                    25.32781
                ],
                [
                    55.354785,
                    25.3252309
                ],
                [
                    55.3536366,
                    25.3217205
                ],
                [
                    55.3510567,
                    25.3173097
                ],
                [
                    55.349566,
                    25.3149952
                ],
                [
                    55.3481499,
                    25.3104341
                ],
                [
                    55.3481232,
                    25.3075555
                ],
                [
                    55.3487874,
                    25.3062475
                ],
                [
                    55.3489674,
                    25.3058927
                ],
                [
                    55.3490607,
                    25.3056863
                ],
                [
                    55.3499579,
                    25.3037857
                ],
                [
                    55.3517334,
                    25.3000061
                ],
                [
                    55.3546301,
                    25.2984196
                ],
                [
                    55.3575268,
                    25.300131
                ],
                [
                    55.363565,
                    25.2978963
                ],
                [
                    55.3677523,
                    25.2973977
                ],
                [
                    55.3719502,
                    25.2967778
                ],
                [
                    55.3756996,
                    25.2973473
                ],
                [
                    55.3783547,
                    25.2984017
                ],
                [
                    55.3821153,
                    25.3004015
                ],
                [
                    55.3858646,
                    25.3024425
                ],
                [
                    55.38917,
                    25.3012495
                ],
                [
                    55.3908293,
                    25.3006505
                ],
                [
                    55.3913122,
                    25.3004753
                ],
                [
                    55.3914565,
                    25.3004234
                ],
                [
                    55.3916047,
                    25.3003649
                ],
                [
                    55.3924404,
                    25.3000345
                ],
                [
                    55.3947172,
                    25.2991357
                ],
                [
                    55.3969966,
                    25.2982366
                ],
                [
                    55.3979399,
                    25.2979296
                ],
                [
                    55.3990693,
                    25.2975612
                ],
                [
                    55.4081727,
                    25.2942126
                ],
                [
                    55.4111308,
                    25.293141
                ],
                [
                    55.4138428,
                    25.2921591
                ],
                [
                    55.4200607,
                    25.289808
                ],
                [
                    55.4207921,
                    25.2895309
                ],
                [
                    55.4215235,
                    25.2892549
                ],
                [
                    55.4229823,
                    25.288703
                ],
                [
                    55.4244344,
                    25.2881532
                ],
                [
                    55.424721,
                    25.2880455
                ],
                [
                    55.4248629,
                    25.2879922
                ],
                [
                    55.4249145,
                    25.2879728
                ],
                [
                    55.4249302,
                    25.2879653
                ],
                [
                    55.4249968,
                    25.287939
                ],
                [
                    55.4258838,
                    25.2875767
                ],
                [
                    55.4305793,
                    25.2856609
                ],
                [
                    55.4308333,
                    25.2855572
                ],
                [
                    55.4310757,
                    25.2854575
                ],
                [
                    55.4315658,
                    25.285258
                ],
                [
                    55.432546,
                    25.2848602
                ],
                [
                    55.434507,
                    25.2840641
                ],
                [
                    55.4384275,
                    25.282471
                ],
                [
                    55.4404536,
                    25.2816486
                ],
                [
                    55.442471,
                    25.2808231
                ],
                [
                    55.4465017,
                    25.2791891
                ],
                [
                    55.4479001,
                    25.2786236
                ],
                [
                    55.4493307,
                    25.2780435
                ],
                [
                    55.4525637,
                    25.277023
                ],
                [
                    55.4540985,
                    25.2765472
                ],
                [
                    55.4577425,
                    25.275222
                ],
                [
                    55.4622453,
                    25.2735864
                ],
                [
                    55.4669711,
                    25.2718527
                ],
                [
                    55.4726575,
                    25.2697627
                ],
                [
                    55.4810058,
                    25.2667651
                ],
                [
                    55.4844043,
                    25.2655653
                ],
                [
                    55.4875639,
                    25.2644844
                ],
                [
                    55.4891773,
                    25.2639293
                ],
                [
                    55.490576,
                    25.2634325
                ],
                [
                    55.4919144,
                    25.2629482
                ],
                [
                    55.492851,
                    25.2626077
                ],
                [
                    55.4937137,
                    25.2622951
                ],
                [
                    55.4946048,
                    25.2619718
                ],
                [
                    55.4954976,
                    25.2616487
                ],
                [
                    55.4978414,
                    25.260799
                ],
                [
                    55.5001798,
                    25.2599432
                ],
                [
                    55.5049611,
                    25.2581465
                ],
                [
                    55.5117699,
                    25.2555863
                ],
                [
                    55.5159005,
                    25.2539752
                ],
                [
                    55.5185113,
                    25.2529533
                ],
                [
                    55.5211248,
                    25.251936
                ],
                [
                    55.5240515,
                    25.2509102
                ],
                [
                    55.5297691,
                    25.248909
                ],
                [
                    55.5315882,
                    25.2481536
                ],
                [
                    55.5331731,
                    25.2474886
                ],
                [
                    55.5353239,
                    25.2465944
                ],
                [
                    55.5386592,
                    25.2452485
                ],
                [
                    55.5422407,
                    25.2438452
                ],
                [
                    55.5459827,
                    25.2423547
                ],
                [
                    55.5479262,
                    25.2415875
                ],
                [
                    55.5490695,
                    25.2411215
                ],
                [
                    55.5494068,
                    25.2409846
                ],
                [
                    55.5497401,
                    25.2408513
                ],
                [
                    55.5501714,
                    25.2406779
                ],
                [
                    55.550598,
                    25.2405082
                ],
                [
                    55.5514506,
                    25.2401663
                ],
                [
                    55.5516058,
                    25.2401046
                ],
                [
                    55.5517184,
                    25.2400595
                ],
                [
                    55.5519396,
                    25.23997
                ],
                [
                    55.5523337,
                    25.2398133
                ],
                [
                    55.5524291,
                    25.239776
                ],
                [
                    55.5525253,
                    25.2397388
                ],
                [
                    55.5527361,
                    25.2396582
                ],
                [
                    55.5531381,
                    25.239505
                ],
                [
                    55.5531996,
                    25.2394818
                ],
                [
                    55.5532672,
                    25.2394562
                ],
                [
                    55.5533982,
                    25.2394062
                ],
                [
                    55.5536361,
                    25.2393154
                ],
                [
                    55.5540745,
                    25.2391483
                ],
                [
                    55.5549579,
                    25.2388122
                ],
                [
                    55.5566885,
                    25.2381527
                ],
                [
                    55.557633,
                    25.2377929
                ],
                [
                    55.5586382,
                    25.2374097
                ],
                [
                    55.5606446,
                    25.2366458
                ],
                [
                    55.5612091,
                    25.2364306
                ],
                [
                    55.5614313,
                    25.2363464
                ],
                [
                    55.5616522,
                    25.2362664
                ],
                [
                    55.562659,
                    25.2359027
                ],
                [
                    55.5646815,
                    25.2351724
                ],
                [
                    55.5649264,
                    25.2350843
                ],
                [
                    55.5652036,
                    25.2349846
                ],
                [
                    55.5656405,
                    25.2348266
                ],
                [
                    55.5665077,
                    25.2345135
                ],
                [
                    55.5682379,
                    25.2338885
                ],
                [
                    55.5716535,
                    25.2326561
                ],
                [
                    55.5810269,
                    25.2289492
                ],
                [
                    55.5813583,
                    25.2288178
                ],
                [
                    55.5816877,
                    25.2286827
                ],
                [
                    55.582362,
                    25.2284209
                ],
                [
                    55.5836944,
                    25.2278975
                ],
                [
                    55.5863484,
                    25.2268409
                ],
                [
                    55.591667,
                    25.2247323
                ],
                [
                    55.5947556,
                    25.2235888
                ],
                [
                    55.5982078,
                    25.2222926
                ],
                [
                    55.6048215,
                    25.2197207
                ],
                [
                    55.6088744,
                    25.2179211
                ],
                [
                    55.6167116,
                    25.2147964
                ],
                [
                    55.6224609,
                    25.2125476
                ],
                [
                    55.6266181,
                    25.2108893
                ],
                [
                    55.6283827,
                    25.2102211
                ],
                [
                    55.6315341,
                    25.2089959
                ],
                [
                    55.6326305,
                    25.2084964
                ],
                [
                    55.6360603,
                    25.2069636
                ],
                [
                    55.650343,
                    25.2357593
                ],
                [
                    55.65987,
                    25.2560213
                ],
                [
                    55.66412,
                    25.2656093
                ],
                [
                    55.669228,
                    25.2763223
                ],
                [
                    55.673534,
                    25.2847763
                ],
                [
                    55.676737,
                    25.2911443
                ],
                [
                    55.682442,
                    25.3023433
                ],
                [
                    55.688152,
                    25.3136683
                ],
                [
                    55.699769,
                    25.3365933
                ],
                [
                    55.729386,
                    25.3949683
                ],
                [
                    55.735778,
                    25.4075763
                ],
                [
                    55.741695,
                    25.4192143
                ],
                [
                    55.702341,
                    25.4167053
                ],
                [
                    55.694359,
                    25.4162103
                ],
                [
                    55.693351,
                    25.4166763
                ],
                [
                    55.672837,
                    25.4219473
                ],
                [
                    55.659083,
                    25.4280323
                ],
                [
                    55.641401,
                    25.43222233
                ],
                [
                    55.641401,
                    25.4324593
                ],
                [
                    55.641401,
                    26.0633666
                ],
                [
                    56.37886231,
                    26.0633666
                ],
                [
                    56.37886231,
                    23.5151492
                ],
                [
                    52.55356498,
                    23.5151492
                ]
            ]
        ],
        "restriction_type": "Drop",
        "start_minutes": 0,
        "end_minutes": 1440,
        "vehicle_ids": [
            4
        ],
        "message": {
            "title": "Restricted area",
            "message": "Drop is restricted in the area due to govt rules"
        }
    },
    {
        "id": 19,
        "polygon": [
            [
                [
                    52.55356498,
                    23.5151492
                ],
                [
                    52.55356498,
                    26.0633666
                ],
                [
                    56.37886231,
                    26.0633666
                ],
                [
                    56.37886231,
                    25.1851703
                ],
                [
                    55.6926692,
                    25.1851703
                ],
                [
                    55.6926692,
                    25.18456595
                ],
                [
                    55.6360603,
                    25.2069633
                ],
                [
                    55.6315341,
                    25.2089956
                ],
                [
                    55.6261944,
                    25.211053
                ],
                [
                    55.6182582,
                    25.2142167
                ],
                [
                    55.6098555,
                    25.2175122
                ],
                [
                    55.6048215,
                    25.2197204
                ],
                [
                    55.5982078,
                    25.2222923
                ],
                [
                    55.591685,
                    25.224733
                ],
                [
                    55.5716535,
                    25.2326558
                ],
                [
                    55.5614072,
                    25.2363548
                ],
                [
                    55.5523995,
                    25.2397863
                ],
                [
                    55.5436487,
                    25.24329
                ],
                [
                    55.5363468,
                    25.2461795
                ],
                [
                    55.5297691,
                    25.2489087
                ],
                [
                    55.5211248,
                    25.2519357
                ],
                [
                    55.5113306,
                    25.2557584
                ],
                [
                    55.4994337,
                    25.2602212
                ],
                [
                    55.489386,
                    25.2638649
                ],
                [
                    55.4835439,
                    25.2658589
                ],
                [
                    55.4726575,
                    25.2697624
                ],
                [
                    55.4607544,
                    25.2741385
                ],
                [
                    55.4540985,
                    25.2765469
                ],
                [
                    55.4493307,
                    25.2780432
                ],
                [
                    55.4311683,
                    25.2854198
                ],
                [
                    55.4249145,
                    25.2879725
                ],
                [
                    55.4138428,
                    25.2921588
                ],
                [
                    55.4068906,
                    25.2946766
                ],
                [
                    55.3990921,
                    25.2975536
                ],
                [
                    55.3969683,
                    25.2982462
                ],
                [
                    55.3914594,
                    25.3004219
                ],
                [
                    55.3858646,
                    25.3024422
                ],
                [
                    55.3818843,
                    25.3002764
                ],
                [
                    55.3783547,
                    25.2984014
                ],
                [
                    55.3756996,
                    25.297347
                ],
                [
                    55.3739965,
                    25.2970817
                ],
                [
                    55.3719502,
                    25.2967775
                ],
                [
                    55.3676808,
                    25.2974052
                ],
                [
                    55.363583,
                    25.297897
                ],
                [
                    55.3575268,
                    25.3001307
                ],
                [
                    55.3546301,
                    25.2984193
                ],
                [
                    55.3517334,
                    25.3000058
                ],
                [
                    55.3489547,
                    25.3059181
                ],
                [
                    55.3481232,
                    25.3075552
                ],
                [
                    55.3481499,
                    25.3104338
                ],
                [
                    55.349566,
                    25.3149949
                ],
                [
                    55.3510567,
                    25.3173094
                ],
                [
                    55.3536366,
                    25.3217202
                ],
                [
                    55.354785,
                    25.3252306
                ],
                [
                    55.3552467,
                    25.3278097
                ],
                [
                    55.3529942,
                    25.3288563
                ],
                [
                    55.346686,
                    25.327162
                ],
                [
                    55.338243,
                    25.332037
                ],
                [
                    55.32979,
                    25.327162
                ],
                [
                    55.321352,
                    25.332034
                ],
                [
                    55.321352,
                    25.341784
                ],
                [
                    55.312903,
                    25.346667
                ],
                [
                    55.312903,
                    25.356416
                ],
                [
                    55.30445,
                    25.361303
                ],
                [
                    55.295997,
                    25.356428
                ],
                [
                    55.287554,
                    25.361303
                ],
                [
                    55.279096,
                    25.356425
                ],
                [
                    55.279091,
                    25.346661
                ],
                [
                    55.287539,
                    25.341778
                ],
                [
                    55.287539,
                    25.332028
                ],
                [
                    55.295987,
                    25.327145
                ],
                [
                    55.295987,
                    25.317401
                ],
                [
                    55.2890362,
                    25.3133946
                ],
                [
                    55.2847974,
                    25.3160185
                ],
                [
                    55.2792134,
                    25.30564
                ],
                [
                    55.2841191,
                    25.3007372
                ],
                [
                    55.2817247,
                    25.2994008
                ],
                [
                    55.279096,
                    25.297894
                ],
                [
                    55.279091,
                    25.288136
                ],
                [
                    55.270652,
                    25.283264
                ],
                [
                    55.262209,
                    25.288139
                ],
                [
                    55.253751,
                    25.283261
                ],
                [
                    55.252201,
                    25.2738911
                ],
                [
                    55.245303,
                    25.268628
                ],
                [
                    55.245298,
                    25.258865
                ],
                [
                    55.2496261,
                    25.252739
                ],
                [
                    55.253746,
                    25.244238
                ],
                [
                    55.245303,
                    25.239363
                ],
                [
                    55.245298,
                    25.229605
                ],
                [
                    55.236859,
                    25.224733
                ],
                [
                    55.228416,
                    25.229608
                ],
                [
                    55.219958,
                    25.22473
                ],
                [
                    55.219953,
                    25.214972
                ],
                [
                    55.21151,
                    25.210097
                ],
                [
                    55.211505,
                    25.200334
                ],
                [
                    55.219953,
                    25.19545
                ],
                [
                    55.219953,
                    25.185707
                ],
                [
                    55.21151,
                    25.180832
                ],
                [
                    55.211505,
                    25.171074
                ],
                [
                    55.203066,
                    25.166202
                ],
                [
                    55.194623,
                    25.171077
                ],
                [
                    55.186165,
                    25.166199
                ],
                [
                    55.18616,
                    25.156441
                ],
                [
                    55.177717,
                    25.151566
                ],
                [
                    55.177712,
                    25.141808
                ],
                [
                    55.169273,
                    25.136936
                ],
                [
                    55.16083,
                    25.141811
                ],
                [
                    55.152377,
                    25.136936
                ],
                [
                    55.143939,
                    25.141808
                ],
                [
                    55.143939,
                    25.151558
                ],
                [
                    55.135486,
                    25.156444
                ],
                [
                    55.127027,
                    25.151566
                ],
                [
                    55.127022,
                    25.141808
                ],
                [
                    55.118584,
                    25.136936
                ],
                [
                    55.110141,
                    25.141811
                ],
                [
                    55.101683,
                    25.136933
                ],
                [
                    55.101678,
                    25.127175
                ],
                [
                    55.093234,
                    25.122301
                ],
                [
                    55.093229,
                    25.112537
                ],
                [
                    55.101678,
                    25.107654
                ],
                [
                    55.101678,
                    25.097904
                ],
                [
                    55.110126,
                    25.093021
                ],
                [
                    55.110126,
                    25.083271
                ],
                [
                    55.118574,
                    25.078388
                ],
                [
                    55.118574,
                    25.068644
                ],
                [
                    55.110136,
                    25.063773
                ],
                [
                    55.101693,
                    25.068647
                ],
                [
                    55.093234,
                    25.06377
                ],
                [
                    55.093229,
                    25.054012
                ],
                [
                    55.084786,
                    25.049137
                ],
                [
                    55.084781,
                    25.039379
                ],
                [
                    55.076343,
                    25.034507
                ],
                [
                    55.067905,
                    25.039379
                ],
                [
                    55.067905,
                    25.049128
                ],
                [
                    55.059451,
                    25.054014
                ],
                [
                    55.050998,
                    25.04914
                ],
                [
                    55.042555,
                    25.054014
                ],
                [
                    55.034097,
                    25.049137
                ],
                [
                    55.034092,
                    25.039379
                ],
                [
                    55.025653,
                    25.034507
                ],
                [
                    55.01721,
                    25.039382
                ],
                [
                    55.008757,
                    25.034507
                ],
                [
                    55.000314,
                    25.039382
                ],
                [
                    54.990831,
                    25.0378509
                ],
                [
                    54.983417,
                    25.039382
                ],
                [
                    54.9747065,
                    25.0386286
                ],
                [
                    54.966521,
                    25.039382
                ],
                [
                    54.958063,
                    25.034504
                ],
                [
                    54.958058,
                    25.024746
                ],
                [
                    54.949614,
                    25.019871
                ],
                [
                    54.949609,
                    25.010113
                ],
                [
                    54.941166,
                    25.005239
                ],
                [
                    54.941161,
                    24.995475
                ],
                [
                    54.949609,
                    24.990591
                ],
                [
                    54.949609,
                    24.980842
                ],
                [
                    54.958058,
                    24.975959
                ],
                [
                    54.958058,
                    24.966215
                ],
                [
                    54.949614,
                    24.96134
                ],
                [
                    54.9475491,
                    24.9522824
                ],
                [
                    54.941171,
                    24.94671
                ],
                [
                    54.932728,
                    24.951585
                ],
                [
                    54.924275,
                    24.94671
                ],
                [
                    54.915831,
                    24.951585
                ],
                [
                    54.9044598,
                    24.9618067
                ],
                [
                    54.8901803,
                    24.9582773
                ],
                [
                    54.890477,
                    24.946707
                ],
                [
                    54.890472,
                    24.936944
                ],
                [
                    54.898925,
                    24.932057
                ],
                [
                    54.907378,
                    24.936932
                ],
                [
                    54.915821,
                    24.932057
                ],
                [
                    54.9155203,
                    24.9243231
                ],
                [
                    54.9218983,
                    24.920696
                ],
                [
                    54.9263615,
                    24.9148383
                ],
                [
                    54.9312046,
                    24.909954
                ],
                [
                    54.941161,
                    24.907678
                ],
                [
                    54.949614,
                    24.902792
                ],
                [
                    54.9548064,
                    24.8991035
                ],
                [
                    54.9604979,
                    24.895944
                ],
                [
                    54.966506,
                    24.893045
                ],
                [
                    54.974959,
                    24.888159
                ],
                [
                    54.9837553,
                    24.8856374
                ],
                [
                    54.9901394,
                    24.8816186
                ],
                [
                    54.9972191,
                    24.8790969
                ],
                [
                    55.004713,
                    24.8774169
                ],
                [
                    55.0063437,
                    24.8712491
                ],
                [
                    55.0091409,
                    24.8686202
                ],
                [
                    55.0115768,
                    24.8673436
                ],
                [
                    55.0225049,
                    24.8616145
                ],
                [
                    55.029028,
                    24.8556807
                ],
                [
                    55.0343003,
                    24.8511858
                ],
                [
                    55.04254,
                    24.849147
                ],
                [
                    55.050993,
                    24.844261
                ],
                [
                    55.0567852,
                    24.8367508
                ],
                [
                    55.0631643,
                    24.8291529
                ],
                [
                    55.067885,
                    24.8241537
                ],
                [
                    55.0660151,
                    24.8143111
                ],
                [
                    55.0664625,
                    24.8089478
                ],
                [
                    55.0722561,
                    24.8008192
                ],
                [
                    55.0777492,
                    24.7951445
                ],
                [
                    55.0873831,
                    24.8000253
                ],
                [
                    55.0915666,
                    24.802958
                ],
                [
                    55.0975954,
                    24.8066229
                ],
                [
                    55.1020796,
                    24.809976
                ],
                [
                    55.1088069,
                    24.8139822
                ],
                [
                    55.1156342,
                    24.8184707
                ],
                [
                    55.1249947,
                    24.8245676
                ],
                [
                    55.1293128,
                    24.8276482
                ],
                [
                    55.131061,
                    24.8286153
                ],
                [
                    55.13952,
                    24.8341165
                ],
                [
                    55.1474215,
                    24.8395128
                ],
                [
                    55.1509671,
                    24.8418137
                ],
                [
                    55.1540457,
                    24.8440663
                ],
                [
                    55.16083,
                    24.849138
                ],
                [
                    55.1655128,
                    24.8527824
                ],
                [
                    55.1739987,
                    24.8604223
                ],
                [
                    55.1804814,
                    24.8665085
                ],
                [
                    55.1850329,
                    24.8705699
                ],
                [
                    55.1876241,
                    24.8735916
                ],
                [
                    55.1887992,
                    24.8745496
                ],
                [
                    55.1936107,
                    24.880259
                ],
                [
                    55.1972851,
                    24.8844695
                ],
                [
                    55.1998487,
                    24.8873804
                ],
                [
                    55.2054743,
                    24.8950613
                ],
                [
                    55.2127319,
                    24.8978125
                ],
                [
                    55.2264546,
                    24.9006236
                ],
                [
                    55.2440978,
                    24.9040765
                ],
                [
                    55.2514678,
                    24.9055267
                ],
                [
                    55.2570072,
                    24.9075848
                ],
                [
                    55.2608713,
                    24.9090196
                ],
                [
                    55.2653233,
                    24.9102757
                ],
                [
                    55.2676456,
                    24.9110511
                ],
                [
                    55.2693986,
                    24.9115978
                ],
                [
                    55.2713661,
                    24.9117554
                ],
                [
                    55.27337,
                    24.912382
                ],
                [
                    55.2758332,
                    24.9127008
                ],
                [
                    55.2781843,
                    24.9134162
                ],
                [
                    55.2888612,
                    24.9150263
                ],
                [
                    55.2976497,
                    24.9164025
                ],
                [
                    55.30148,
                    24.9171162
                ],
                [
                    55.3053128,
                    24.9170224
                ],
                [
                    55.3122358,
                    24.9183293
                ],
                [
                    55.3147524,
                    24.9185283
                ],
                [
                    55.3183368,
                    24.9185822
                ],
                [
                    55.328014,
                    24.9212026
                ],
                [
                    55.3431202,
                    24.9193755
                ],
                [
                    55.3649195,
                    24.9226074
                ],
                [
                    55.3952167,
                    24.9223739
                ],
                [
                    55.4185613,
                    24.9293775
                ],
                [
                    55.4612393,
                    24.9367709
                ],
                [
                    55.4814303,
                    24.9452542
                ],
                [
                    55.5012142,
                    24.9527249
                ],
                [
                    55.5105711,
                    24.9545924
                ],
                [
                    55.5146909,
                    24.9557795
                ],
                [
                    55.5301416,
                    24.9582503
                ],
                [
                    55.5437065,
                    24.9684416
                ],
                [
                    55.5653472,
                    24.9779555
                ],
                [
                    55.5833805,
                    24.9879389
                ],
                [
                    55.5859621,
                    24.992553
                ],
                [
                    55.5887125,
                    24.9956109
                ],
                [
                    55.5908191,
                    24.9995566
                ],
                [
                    55.593914,
                    25.0052801
                ],
                [
                    55.5968814,
                    25.0100876
                ],
                [
                    55.5984265,
                    25.0135423
                ],
                [
                    55.599848,
                    25.0167945
                ],
                [
                    55.6007062,
                    25.0210218
                ],
                [
                    55.6040004,
                    25.0243433
                ],
                [
                    55.6070095,
                    25.0281976
                ],
                [
                    55.6083235,
                    25.0336939
                ],
                [
                    55.6116409,
                    25.0379838
                ],
                [
                    55.6122641,
                    25.042251
                ],
                [
                    55.6143291,
                    25.0456446
                ],
                [
                    55.6161215,
                    25.0482056
                ],
                [
                    55.5577928,
                    25.0936889
                ],
                [
                    55.5662042,
                    25.0955544
                ],
                [
                    55.5716974,
                    25.097653
                ],
                [
                    55.5753881,
                    25.0990521
                ],
                [
                    55.5835421,
                    25.1023166
                ],
                [
                    55.5896078,
                    25.1046135
                ],
                [
                    55.5923101,
                    25.1055266
                ],
                [
                    55.5950025,
                    25.1069841
                ],
                [
                    55.5966758,
                    25.1081691
                ],
                [
                    55.604518,
                    25.1119192
                ],
                [
                    55.6114311,
                    25.1155554
                ],
                [
                    55.622594,
                    25.1226745
                ],
                [
                    55.6357399,
                    25.1312503
                ],
                [
                    55.6445933,
                    25.1362502
                ],
                [
                    55.6609337,
                    25.1433409
                ],
                [
                    55.6817513,
                    25.1636015
                ],
                [
                    55.6858762,
                    25.1683885
                ],
                [
                    55.6884827,
                    25.1717104
                ],
                [
                    55.6896894,
                    25.1777411
                ],
                [
                    55.69305018,
                    25.1831703
                ],
                [
                    55.6936692,
                    25.1831703
                ],
                [
                    56.37886231,
                    25.1831703
                ],
                [
                    56.37886231,
                    23.5151492
                ],
                [
                    52.55356498,
                    23.5151492
                ]
            ]
        ],
        "restriction_type": "Drop",
        "start_minutes": 0,
        "end_minutes": 1440,
        "vehicle_ids": [
            3
        ],
        "message": {
            "title": "Restricted area",
            "message": "Drop is restricted in the area due to govt rules"
        }
    }
]};

export {
  value ,
  
}
/* No side effect */
